import { render, staticRenderFns } from "./AssessmentHelper.vue?vue&type=template&id=19fe2f5b&scoped=true&"
import script from "./AssessmentHelper.vue?vue&type=script&lang=js&"
export * from "./AssessmentHelper.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentHelper.vue?vue&type=style&index=0&id=19fe2f5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe2f5b",
  null
  
)

export default component.exports